export default "__VITE_ASSET__CO54u$_w__"